import React, { useEffect } from 'react';
import { FormattedMessage } from 'react-intl';
import { useDispatch, useSelector } from 'react-redux';
import { push } from 'react-router-redux';
import { isEmpty, capitalize } from 'lodash';
import moment from 'moment';
import { Paper, FontIcon, ListItem, FlatButton, MenuItem, SelectField } from 'material-ui';

import { fetchUserPayslips, downloadFile, setPayYear, initPayYear } from 'actions/Files';
import PanelMessage from 'components/panels/PanelMessage';
import KFlatButton from 'components/KJRN/KFlatButton';
import styles from 'styles/TBenefits';
import TLoading from './TLoading';
import TMessage from './TMessage';

const TPayslips = () => {
  const dispatch = useDispatch();
  const { FileReducer, languageReducer } = useSelector(state => state);
  const {
    payslipsLoaded, payslips, payYear, payYearOptions, hasError, error,
  } = FileReducer;
  const { language } = languageReducer;
  moment.locale(language);

  useEffect(() => {
    dispatch(initPayYear());
  }, [dispatch]);

  if (!payslipsLoaded) return <TLoading />;

  if (hasError) {
    return (
      <PanelMessage
        type="error"
        iconName="error"
        message={error && error.Message ? error.Message : <FormattedMessage id="payslip.error" />}
      />
    );
  }

  if (isEmpty(payslips)) {
    return (
      <TMessage message="tile.payslips.empty">
        <KFlatButton
          style={styles.actionButton}
          onClick={() => dispatch(push('/payslip'))}
          containerStyle={styles.action}
          label={<FormattedMessage id="tile.payslips.goto" />}
        />
      </TMessage>
    );
  }

  const setYear = (year) => {
    dispatch(setPayYear(year));
    dispatch(fetchUserPayslips());
  };

  const download = id => dispatch(downloadFile(id));

  return (
    <div style={styles.container}>
      <div style={{ maxHeight: 422, overflow: 'auto', height: '100%' }}>
        <SelectField
          floatingLabelText={<FormattedMessage id="payslip.select" />}
          value={payYear}
          onChange={(a, b, value) => setYear(value)}
        >
          {payYearOptions.map(y => <MenuItem key={y} value={y} primaryText={y} />)}
        </SelectField>
        <Paper>
          {payslips.map(slip => (
            <ListItem
              key={slip.PaySlipGuid}
              style={{ paddingLeft: 0 }}
              primaryText={capitalize(moment().month(slip.PayMonth).format('MMMM'))}
              disabled
              secondaryText={`${moment(slip.PayPeriodBegda).format('LL')} - ${moment(slip.PayPeriodEndda).format('LL')}`}
              rightIconButton={<FlatButton
                style={{ top: 'auto', right: 0, minWidth: '24px' }}
                onClick={() => download(slip.PaySlipGuid)}
                icon={<FontIcon className="material-icons">file_download</FontIcon>}
              />}
            />
        ))}
        </Paper>
      </div>
      <KFlatButton
        style={styles.actionButton}
        onClick={() => dispatch(push('/payslip'))}
        containerStyle={styles.action}
        label={<FormattedMessage id="tile.payslips.goto" />}
      />
    </div>
  );
};

export default TPayslips;



// WEBPACK FOOTER //
// ./src/containers/tiles/TPayslips.js